import { CommunitiesResultProfile } from '../server/types';
import { UserPost } from '../types/posts';
import { userStateData } from './userStateData';

// Commnuity state data class
class CommunityStateData {
	communityProfiles: CommunitiesResultProfile[] = [{
			id: '1',
			name: 'Community Name #1',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		},{
			id: '2',
			name: 'Community Name #2',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		},{
			id: '3',
			name: 'Community Name #3',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		},{
			id: '4',
			name: 'Community Name #4',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		},{
			id: '5',
			name: 'Community Name #5',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		},{
			id: '6',
			name: 'Community Name #6',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		},{
			id: '7',
			name: 'Community Name #7',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		}
	]

	userPosts: UserPost[] = [{
			postId: '1',
			sourceName: 'Test User',
			community: 'Community Name #1',
			sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'This is an example test post',
			postImgSrc: undefined,
			verified: true
		}
	]
	// 	{
	// 		postId: '1',
	// 		sourceName: 'Test User',
	// 		community: 'Community Name',
	// 		sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
	// 		postDate: 0,
	// 		postMsg: 'This is an example fake post used for testing the front end layout',
	// 		postImgSrc: undefined,
	// 		verified: true
	// 	},{
	// 		postId: '2',
	// 		sourceName: 'Test User',
	// 		community: 'Community Name',
	// 		sourceImgSrc: userStateData.getUserIconUrl() || '',
	// 		postDate: 0,
	// 		postMsg: 'This is an example fake post with an image',
	// 		postImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl(),
	// 		verified: true
	// 	},{
	// 		postId: '3',
	// 		sourceName: 'Test User',
	// 		community: 'Community Name',
	// 		sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
	// 		postDate: 0,
	// 		postMsg: 'Another fake post to test stacked posts in layout',
	// 		postImgSrc: undefined,
	// 		verified: true
	// 	}
	// ]
	// [
	// 	{
	// 		id: '1',
	// 		name: 'Community Name',
	// 		profile_pic: '/imgs/temp/community/temp-icon.png'
	// 	},{
	// 		id: '2',
	// 		name: 'Skiing Community',
	// 		profile_pic: '/imgs/temp/community/temp-comm_01.jpg'
	// 	},{
	// 		id: '3',
	// 		name: 'Other Com',
	// 		profile_pic: '/imgs/temp/community/temp-comm_02.png'
	// 	},{
	// 		id: '4',
	// 		name: 'Example',
	// 		profile_pic: '/imgs/temp/community/temp-comm_03.jpg'
	// 	},{
	// 		id: '1',
	// 		name: 'Additional',
	// 		profile_pic: '/imgs/temp/community/temp-icon.png'
	// 	},{
	// 		id: '2',
	// 		name: 'New',
	// 		profile_pic: '/imgs/temp/community/temp-comm_01.jpg'
	// 	}
	// ]
	
	constructor() {
	}
}

export const communityStateData: CommunityStateData = new CommunityStateData()